import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import FileUploadImage from "./ImageGroup";
import EmployeeModal from "./EmployeeModal";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [PartyName, setPartyName] = React.useState(FetchData.meta.expense_title)

  const [Amount, setAmount] = React.useState(FetchData.meta.amount)
  const [TDS, setTDS] = React.useState(FetchData.meta.tds)
  const [AfterTDS, setAfterTDS] = React.useState(FetchData.meta.aftertds)
  const [PaymentDate, setPaymentDate] = React.useState(FetchData.meta.payment_date)

  const [Type, setType] = React.useState(FetchData.meta.type)
  const [Remarks1, setRemarks1] = React.useState(FetchData.meta.remarks1)
  const [Remarks2, setRemarks2] = React.useState(FetchData.meta.remarks2)
  const [Remarks3, setRemarks3] = React.useState(FetchData.meta.remarks3)

  const [EmployeeFetch, setEmployeeFetch] = React.useState(false)
  const [EmployeeID, setEmployeeID] = React.useState(FetchData.meta.employee_id)
  const [EmployeeName, setEmployeeName] = React.useState(FetchData.meta.employee_name)
  const [EmployeeSlug, setEmployeeSlug] = React.useState(FetchData.meta.employee_slug)
  const [EmployeeType, setEmployeeType] = React.useState(FetchData.meta.employee_type)
  const [Screenshot, setScreenshot] = React.useState(FetchData.meta.screenshot == "" ? [] : JSON.parse(FetchData.meta.screenshot))

  const [ShowScreenShotGroupList, setShowScreenShotGroupList] = React.useState(true)

  const [ShowBillsGroupList, setShowBillsGroupList] = React.useState(true)

  const [Bills, setBills] = React.useState(FetchData.meta.bills == "" ? [] : JSON.parse(FetchData.meta.bills))

  const [EmployeeListModal, setEmployeeListModal] = React.useState(false)
  const [EmployeeList, setEmployeeList] = React.useState([])

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")


  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "expense_title": `${PartyName}`,
        "amount": `${Amount}`,
        "tds": `${TDS}`,
        "aftertds": `${AfterTDS}`,
        "type": `${Type}`,
        "payment_date":`${PaymentDate}`,
        "employee_id": `${EmployeeID}`,
        "employee_name": `${EmployeeName}`,
        "employee_slug": `${EmployeeSlug}`,
        "employee_type": `${EmployeeType}`,
        "remarks1": `${Remarks1}`,
        "remarks2": `${Remarks2}`,
        "remarks3": `${Remarks3}`,
        "screenshot": JSON.stringify(Screenshot),
        "bills": JSON.stringify(Bills)
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_expenses)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Added Successfully")
          history.push(`${slugs.expenses_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_expenses, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`Successfully Edited`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }

  const location = useLocation()

  // const [searchParams] =

  useEffect(() => {
    GetAllStudents()
  }, [])

  const GetAllStudents = (params) => {
    setEmployeeList([])
    AdsGETApiAuth(
      {
        per_page: 10000,
        _fields: "id,title,slug,meta"
      }, slugs.db_slug_employee)
      .then((res) => {
        setEmployeeList(res.data)
        if (location.search.search("staff_id") !== -1) {
          var value_search = location.search.search("staff_id") + 9
          var index = location.search.slice(value_search)
          var search_student = res.data.filter(a => a.id == index)
          if (search_student.length == 1) {
            const date = new Date()
            setTitle(`${search_student[0].meta.name} Payment ${date.toDateString()}`)
            setEmployeeID(search_student[0].id)
            setEmployeeName(search_student[0].meta.name)
            setEmployeeSlug(search_student[0].slug)
            setEmployeeType(search_student[0].meta.type)
            if (search_student[0].meta.type == "Staff")
              setType("Salary Payment")
            else if (search_student[0].meta.type == "Teacher")
              setType("Teacher Payment")
          }
        }

      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }


  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Expense Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Party Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={PartyName} placeholder="Party Name"
                    onChange={(event) => { setPartyName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Title</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Title"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Amount</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Amount} placeholder="Amount"
                    onChange={(event) => {

                      setAmount(event.target.value)
                      setTDS(Number(event.target.value) * 0.15)
                      setAfterTDS(Number(event.target.value) * 0.85)
                    }}
                  />
                </td>
              </tr>
              {/* {Type == "Teacher Payment" && */}
              <tr>
                <td className="col-3">TDS</td>
                <td className="col-6">
                  <input className="input-common"
                    value={TDS} placeholder="Amount"
                    onChange={(event) => {
                      setTDS(event.target.value)
                      setAfterTDS(Number(Amount) - Number(event.target.value))

                    }}
                  />
                </td>
              </tr>
              {/* }
              {Type == "Teacher Payment" && */}
              <tr>
                <td className="col-3">After TDS</td>
                <td className="col-6">
                  <input className="input-common" disabled
                    value={AfterTDS} placeholder="Amount"
                    onChange={(event) => { setAfterTDS(event.target.value) }}
                  />
                </td>
              </tr>
                <tr>
                <td className="col-3">Payment Date</td>
                {/* <td className="col-6">
                  <input className="input-common" disabled
                    value={FetchData.date.slice(0, 10)} placeholder="Payment Date"
                    onChange={(event) => { setPaymentDate(event.target.value) }}
                  />
                </td> */}
                <td className="nepali-date-cell">
                  {/* <div className="topic-popup"> */}
                  <div className="attendance-date-picker">
                    <div className="small-nepali-datepicker"
                    >
                      {/* {item.date} */}
                      <NepaliDatePicker style={{ cursor: "pointer" }}
                        inputClassName="input-common" placeholder={"date"}
                        value={PaymentDate || ""}
                        onChange={(selectedDate) => {
                          setPaymentDate(selectedDate)
                        }
                        }
                        options={{
                          calenderLocale: "ne",
                          valueLocale: "en",
                        }}
                        placeholder="मिति छान्नुहोस्"
                      // onSelect={() => { setOpencalendar(true) }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              {/* } */}
              <tr>
                <td className="col-3">Type</td>
                <td className="col-6">
                  {/* <input className="input-common"
                    value={Type} placeholder="Type"
                    onChange={(event) => { setType(event.target.value) }}
                  /> */}
                  <CustomButton setData={setType} Data={Type} DataValue={"Food"} />
                  <CustomButton setData={setType} Data={Type} DataValue={"Rent"} />
                  <CustomButton setData={setType} Data={Type} DataValue={"Water and Electricity"} />
                  <CustomButton setData={setType} Data={Type} DataValue={"Stationery"} />
                  <CustomButton setData={setType} Data={Type} DataValue={"Extra"} />
                  <CustomButton setData={setType} Data={Type} DataValue={"Teacher Payment"} />
                  <CustomButton setData={setType} Data={Type} DataValue={"Salary Payment"} />
                </td>
              </tr>
              {(Type == "Teacher Payment" || Type == "Salary Payment") &&
                <>
                  {/* <tr>
                    <td className="col-3">Staff Type</td>
                    <td className="col-6">
                      <div className="input-common">
                        {EmployeeType}&nbsp;
                      </div>
                    </td>
                  </tr> */}
                  <tr>
                    <td className="col-3">{EmployeeType} ID</td>
                    <td className="col-6" >
                      <div className="input-common" onClick={() => {
                        if (!EmployeeFetch)
                          setEmployeeListModal(true)
                      }}>
                        {EmployeeID}&nbsp;
                      </div>
                      {/* <input className="input-common" disabled
                                  value={StudentID} placeholder="StudentID"
                                  onChange={(event) => { setStudentID(event.target.value) }}
                                /> */}
                    </td>
                  </tr>
                  <tr>
                    <td className="col-3">{EmployeeType} Name</td>
                    <td className="col-6">
                      <div className="input-common"
                        onClick={() => {
                          if (!EmployeeFetch)
                            setEmployeeListModal(true)
                        }}>
                        {EmployeeName}&nbsp;
                      </div>
                      {/* <input className="input-common" disabled
                                  value={StudentName} placeholder="Student Name"
                                  onChange={(event) => { setStudentName(event.target.value) }}
                                /> */}
                      {EmployeeSlug !== "" &&
                        <a className="Link" href={`${slugs.employee_details}${EmployeeSlug}`}>
                          View
                        </a>
                      }
                    </td>
                  </tr>
                </>}

              <tr>
                <td className="col-3">Screenshot</td>
                <td className="col-6">
                  {ShowScreenShotGroupList &&
                    <div style={{ padding: "0 10px" }}>
                      {Object.values(Screenshot).map((item, index) => (
                        <div key={index} style={{ display: "flex", padding: "3px 0" }}>
                          <span style={{ padding: "10px 5px" }}>   {index + 1} . &nbsp;</span>
                          <span>
                            <FileUploadImage
                              ImageGroup={Screenshot}
                              setImageGroup={setScreenshot}
                              ThisImage={item}
                              index={index}
                            />
                          </span>
                          <span style={{ cursor: "pointer", padding: "10px 5px" }} onClick={() => {
                            var ObjectForDelete = Screenshot
                            var key = Object.keys(Screenshot)[index]
                            console.log(key, Screenshot)
                            delete ObjectForDelete[key];
                            setScreenshot(ObjectForDelete)
                            setShowScreenShotGroupList(false)
                            setTimeout(() => {
                              setShowScreenShotGroupList(true)
                            }, 10)
                          }}>
                            Delete
                          </span>
                        </div>
                      ))}
                      <div className=" col-3" style={{ padding: "0 10px" }}>
                        <div className="sign-in-button-small"
                          onClick={() => {
                            var newValue = ""
                            var lastkey = Object.keys(Screenshot).length == 0 ? -1 : Number(Object.keys(Screenshot)[Object.keys(Screenshot).length - 1])
                            console.log(lastkey + 1)
                            var newKey = `${lastkey + 1}`
                            var newObject = Screenshot;
                            newObject = {
                              ...Screenshot,
                              [newKey]: newValue
                            }
                            console.log(newObject)

                            setScreenshot(newObject)
                          }}
                        >
                          Add Screenshot
                        </div>
                      </div>
                    </div>
                  }
                </td>
              </tr>

              <tr>
                <td className="col-3">Bills</td>
                <td className="col-6">
                  {ShowBillsGroupList &&
                    <div style={{ padding: "0 10px" }}>
                      {Object.values(Bills).map((item, index) => (
                        <div key={index} style={{ display: "flex", padding: "3px 0" }}>
                          <span style={{ padding: "10px 5px" }}>   {index + 1} . &nbsp;</span>
                          <span>
                            <FileUploadImage
                              ImageGroup={Bills}
                              setImageGroup={setBills}
                              ThisImage={item}
                              index={index}
                            />
                          </span>
                          <span style={{ cursor: "pointer", padding: "10px 5px" }} onClick={() => {
                            var ObjectForDelete = Bills
                            var key = Object.keys(Bills)[index]
                            console.log(key, Bills)
                            delete ObjectForDelete[key];
                            setBills(ObjectForDelete)
                            setShowBillsGroupList(false)
                            setTimeout(() => {
                              setShowBillsGroupList(true)
                            }, 10)
                          }}>
                            Delete
                          </span>
                        </div>
                      ))}
                      <div className=" col-3" style={{ padding: "0 10px" }}>
                        <div className="sign-in-button-small"
                          onClick={() => {
                            var newValue = ""
                            var lastkey = Object.keys(Bills).length == 0 ? -1 : Number(Object.keys(Bills)[Object.keys(Bills).length - 1])
                            console.log(lastkey + 1)
                            var newKey = `${lastkey + 1}`
                            var newObject = Bills;
                            newObject = {
                              ...Bills,
                              [newKey]: newValue
                            }
                            console.log(newObject)

                            setBills(newObject)
                          }}
                        >
                          Add Bills
                        </div>
                      </div>
                    </div>
                  }
                </td>
              </tr>
              <tr>
                <td className="col-3">Remarks 1</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Remarks1} placeholder="Remarks 1"
                    onChange={(event) => { setRemarks1(event.target.value) }}
                  />
                </td>
              </tr>
              {Remarks1 !== "" &&
                <tr>
                  <td className="col-3">Remarks 2</td>
                  <td className="col-6">
                    <input className="input-common"
                      value={Remarks2} placeholder="Remarks 2"
                      onChange={(event) => { setRemarks2(event.target.value) }}
                    />
                  </td>
                </tr>
              }
              {Remarks2 !== "" &&
                <tr>
                  <td className="col-3">Remarks 3</td>
                  <td className="col-6">
                    <input className="input-common"
                      value={Remarks3} placeholder="Remarks 3"
                      onChange={(event) => { setRemarks3(event.target.value) }}
                    />
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Expenses
              </div>
            </div>
          </div>
        </div>
      </div >

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
      {
        EmployeeListModal &&
        <section className="modal" >
          <div className="row">
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'scroll', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setEmployeeListModal(false)
                  }}
                >X</div>
                <EmployeeModal
                  setEmployeeID={setEmployeeID}
                  setEmployeeName={setEmployeeName}
                  setEmployeeSlug={setEmployeeSlug}
                  EmployeeID={EmployeeID}
                  setEmployeeModal={EmployeeListModal}
                  EmployeesList={EmployeeList}
                />
              </div>
            </div>
          </div>
        </section>
      }
    </div >
  )

}